@switch (viewState()) {
  @case ('list') {
    <dojo-filterable-items-list
      [items]="tags()"
      [selected]="selectedIds()"
      [identityFn]="identityFn"
      [filterPropertyValueFn]="filterPropertyValueFn"
      [searchPlaceholder]="'examdojo.tags.search_placeholder' | transloco"
      [emptyListLabel]="'examdojo.tags.no_tags_found' | transloco"
      [enableCreateItemButton]="true"
      [createItemButtonLabel]="'examdojo.tags.create_new_tag_short' | transloco"
      listMode="toggled-list"
      (selectionChange)="onSelectionChange($event)"
      (createItem)="onCreateItem($event)"
      [size]="'xs'"
    >
      <div *dojoListItem="tags(); let tag" class="option-item">
        <dojo-tag-badge class="flex-1 truncate" [name]="tag.name" [color]="tag.color" [emoji]="tag.emoji" />
        @if (!tag.isSystem) {
          <dojo-icon icon="ellipsis" class="text-secondary flex" (click)="$event.stopPropagation(); openEditView(tag)">
          </dojo-icon>
        }
      </div>
    </dojo-filterable-items-list>
  }
  @case ('create') {
    <dojo-tag-editor [prefill]="{ name: createTagName() }" [showDelete]="false" (save)="onCreate($event)" />
  }
  @case ('edit') {
    @if (editingTag(); as tag) {
      <dojo-tag-editor
        [prefill]="{ name: tag.name, color: tag.color, emoji: tag.emoji }"
        [showDelete]="!tag.isSystem"
        (save)="onUpdate($event)"
        (delete)="onDelete()"
      />
    }
  }
}
